import { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useCompany } from "../contexts/CompanyContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useUnreadMessages = () => {
  const { companyId } = useCompany();
  const [unreadCount, setUnreadCount] = useState(0);
  const initialFetchDone = useRef(false);

  const fetchUnreadCount = useCallback(async () => {
    if (!companyId) return;
    
    const token = localStorage.getItem("token");
    if (!token) return;
    
    try {
      const response = await axios.get(`${API}/messages/unread-count`, {
        params: { company_id: companyId },
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadCount(response.data.unread_count);
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  }, [companyId]);

  useEffect(() => {
    // Initial fetch on mount
    if (!initialFetchDone.current && companyId) {
      initialFetchDone.current = true;
      fetchUnreadCount();
    }
    
    // Poll every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => clearInterval(interval);
  }, [companyId, fetchUnreadCount]);

  return { unreadCount, refreshUnreadCount: fetchUnreadCount };
};

export default useUnreadMessages;
